var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4 9V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V9", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" }),
    React.createElement("path", { d: "M2 10L10.971 4.6174C11.6044 4.23738 12.3956 4.23738 13.029 4.61739L22 10", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" }),
    React.createElement("path", { d: "M9.10263 12.6325L8 13L9.10263 13.3675C10.2971 13.7657 11.2343 14.7029 11.6325 15.8974L12 17L12.3675 15.8974C12.7657 14.7029 13.7029 13.7657 14.8974 13.3675L16 13L14.8974 12.6325C13.7029 12.2343 12.7657 11.2971 12.3675 10.1026L12 9L11.6325 10.1026C11.2343 11.2971 10.2971 12.2343 9.10263 12.6325Z", fill: "#303030" })
  );
});